import { Role } from 'model/IChat';
import React from 'react';
import MenuItem from 'reusable-components/navigation/NavigationMenuList/MenuItem';
import { hasAnyOfRoles } from 'utils/AccountRoles';
import { becomeYourself } from 'utils/impersonate';

type AdminMenuItemsProps = {
  onLinkClick: () => void;
  roles: Role[];
};

const AdminMenuItems = ({ onLinkClick, roles }: AdminMenuItemsProps) => {
  return (
    <>
      {hasAnyOfRoles(roles, 'impersonator') && (
        <MenuItem
          text="Become yourself again"
          onClick={async () => {
            await becomeYourself();
            onLinkClick();
          }}
          isExternalLink
        />
      )}
      <MenuItem
        text="Impersonate someone"
        url={`${URL_STOREFRONT_HOST}/storefront-admin/impersonate`}
        onClick={onLinkClick}
        isExternalLink
      />
      <MenuItem
        text="Feature Flags"
        url="/feature-flags/"
        onClick={onLinkClick}
      />
      <MenuItem text="AB tests" url="/ab-tests/" onClick={onLinkClick} />
    </>
  );
};

export default AdminMenuItems;
